import { FC } from 'react';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { FORECASTING_THEME } from '../forecastingTheme';

interface DrillHeaderProps {
  title: string;
  canUp: boolean;
  canDown: boolean;
  onDrillUp: () => void;
  onDrillDown: () => void;
}

export const DrillHeader: FC<DrillHeaderProps> = ({
  title,
  canUp,
  canDown,
  onDrillUp,
  onDrillDown
}) => (
  <span className="drill-header" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
    {title}
    <span className="drill-header-arrows" style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1 }}>
      <button
        type="button"
        className="drill-header-btn"
        disabled={!canUp}
        onClick={(e) => {
          e.stopPropagation();
          onDrillUp();
        }}
        aria-label="Drill up"
      >
        <CaretUpOutlined />
      </button>
      <button
        type="button"
        className="drill-header-btn"
        disabled={!canDown}
        onClick={(e) => {
          e.stopPropagation();
          onDrillDown();
        }}
        aria-label="Drill down"
      >
        <CaretDownOutlined />
      </button>
    </span>
  </span>
);

export const DRILL_HEADER_BTN_CSS = `
  .drill-header-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 14px;
    padding: 0;
    border: none;
    background: transparent;
    color: ${FORECASTING_THEME.accentOrange};
    cursor: pointer;
    font-size: 11px;
    opacity: 1;
  }
  .drill-header-btn:disabled {
    opacity: 0.3;
    cursor: default;
    color: ${FORECASTING_THEME.textMuted};
  }
  .drill-header-btn:not(:disabled):hover {
    color: ${FORECASTING_THEME.forecast};
  }
`;
